import classNames from 'classnames';
import React from 'react'


interface IconProps {
  name: string;                  // The name of the icon (e.g., 'home', 'user')
  id?: string;                   // Optional id for the icon element
  className?: string;            // Additional CSS classes for the icon
  style?: React.CSSProperties;   // Inline styles for the icon
  [key: string]: any;            // Any other props like aria-label or data attributes
}



const Icon: React.FC<IconProps> = ({ name, id, className, style, ...props }) => {
    const iconClass = classNames({
      [`${className}`]: className,
      icon: true,
      fa: true,
      [`fa-${name}`]: true,
    });
    return <i className={iconClass} id={id} style={style} {...props}></i>;
  };
export default Icon;
  
